'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/chart.js/src/charts/Chart.Doughnut.js
// module id = ../../../../chart.js/src/charts/Chart.Doughnut.js
// module chunks = 4